import * as React from 'react';

import CompanyFeatureFlagsEnum, { CompanyFeatureFlagsTips } from 'ab-enums/companyFeatureFlags.enum';

import PreviewItem from '../../Shared/PreviewItem';
import SettingPreview from '../../Shared/SettingPreview';

type Props = {
	areMaterialsEnabled: boolean;
	toggleEdit: () => void;
};

const EnableMaterialsPreview: React.FC<Props> = ({ areMaterialsEnabled, toggleEdit }) => {
	return (
		<SettingPreview toggleEdit={toggleEdit}>
			<div className="company-settings__info-segment">
				<PreviewItem
					checked={!!areMaterialsEnabled}
					hint={CompanyFeatureFlagsTips.materials}
					indent={false}
					label={CompanyFeatureFlagsEnum.areMaterialsEnabled}
					showCheckbox={true}
				/>
			</div>
		</SettingPreview>
	);
};

export default React.memo(EnableMaterialsPreview);
